import React, { useContext } from 'react';
import styled from 'styled-components';
import HeaderContext from '../../HeaderContext';
import { GA_CATEGORY } from '../constants';
import { DropdownLink, DropdownRow } from './styles';

const Frame = styled.div`
  width: 230px;
`;

type CategoryLinkRow = { key: string; value: string };
type Props = {
  items: CategoryLinkRow[];
  footer: { key: string; desc: string; value: string };
  sourceType: string;
};

const Dropdown: React.FC<Props> = ({
  items = [],
  footer = { key: '', desc: '', value: '' },
  sourceType
}) => {
  const { siteSource } = useContext(HeaderContext);
  return (
    <Frame>
      <DropdownRow>
        {items.map(({ value, key }) => (
          <DropdownLink
            key={key}
            href={key}
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked ${sourceType} ${value} - Sub Menu`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            {value}
          </DropdownLink>
        ))}
      </DropdownRow>
      <DropdownRow hasBreak={true}>
        <DropdownLink
          isFooter={true}
          href={footer.key}
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked Browse All ${footer.desc} Categories - Sub Menu`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
        >
          {footer.value}
        </DropdownLink>
      </DropdownRow>
    </Frame>
  );
};

export default Dropdown;
